module.exports = __webpack_public_path__ + "img/34th_front_left.1a5535ed.jpg";